export default __webpack_public_path__ + "static/database-23154256b11f6bf94cf169395a0bd6f5.jpg";